import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgArrowLeft = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.31045 3.35617C7.51874 3.56444 7.51874 3.90213 7.31045 4.11041L3.95425 7.46662H13.3333C13.6278 7.46662 13.8667 7.7054 13.8667 7.99995C13.8667 8.2945 13.6278 8.53329 13.3333 8.53329H3.95425L7.31045 11.8894C7.51874 12.0978 7.51874 12.4355 7.31045 12.6438C7.10218 12.852 6.76449 12.852 6.55621 12.6438L2.28955 8.37707C2.08126 8.1688 2.08126 7.83111 2.28955 7.62283L6.55621 3.35617C6.76449 3.14788 7.10218 3.14788 7.31045 3.35617Z"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgArrowLeft)
const IconSvgArrowLeft = createIcon(ForwardRef, 'SvgArrowLeft')
export default IconSvgArrowLeft
